<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="mt-1"
    elevation="0"
  >
    <v-card-text>
      <h1>{{ address.lastName.trim() }} {{ address.firstName.trim() }}</h1>
      <p class="mt-2">
        {{ address.addressLine1 }}
        <template v-if="address.addressLine2">
          {{ address.addressLine2 }}<br>
        </template>

        {{ address.city }} {{ address.plz }}<br>
        <span class="font-weight-bold">{{ $t('emailAddress') }} </span>{{ address.email }}<br>
        <span class="font-weight-bold">{{ $t('telephone') }} </span>{{ address.tel }}<br>
        <span class="font-weight-bold">{{ $t('deliveryTime') }} </span>{{ address.date }} {{ address.time }}<br>
        {{ address.note }}
      </p>
      <v-chip v-if="address.deliveryMethod">
        {{ address.deliveryMethod }}
      </v-chip>
      <v-chip v-if="address.reason">
        {{ address.reason }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
const DefaultAddressInfo = {
  lastName: '',
  firstName: '',
  reason: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  plz: '',
  tel: '',
  email: '',
  date: '',
  time: '',
  note: '',
  deliveryMethod: ''
}
export default {
  name: 'AddressInfoBlock',
  props: {
    addressInfo: {
      type: Object,
      default: () => DefaultAddressInfo
    }
  },
  // data: function () {
  //   return Object.assign({}, DefaultAddressInfo, this.addressInfo)
  // },
  computed: {
    address () {
      return Object.assign({}, DefaultAddressInfo, this.addressInfo)
    }
  }
}
</script>

<style scoped>

</style>
